import { Button, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { AppModels, AppState, brandNewQuote, hasErrors, saveModel, selectPorjectQuotes } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoadingBackdrop } from '../utils/LoadingBackdrop';

export const QuoteList = (props: { projectId: ModelId; }) => {

    const [loading, setLoading] = React.useState(false);
    const quotes = useSelector((state: AppState) => selectPorjectQuotes(state, props.projectId));
    const navigate = useNavigate();

    const onNewQuoteClick = async () => {
        setLoading(true);
        const response = await saveModel(AppModels.quotes, {
            ...brandNewQuote,
            projectId: props.projectId
        });
        if (!hasErrors(response)) {
            navigate('/project/' + props.projectId + '/quote/' + response.id);
        }
    };

    return <>
        {loading && <LoadingBackdrop caption='Création en cours...' />}
        <Button variant='contained' onClick={onNewQuoteClick}>Créer une soumission</Button>
        {quotes.length == 0 && <Typography>Aucune soumission</Typography>}
        {quotes.map(quote => <Card key={quote.id}>
            <CardHeader>Soumission # {quote.id.toString().padStart(3, '0')}</CardHeader>
            <CardContent><strong>État :</strong>{quote.state}</CardContent>
        </Card>)}</>;

};
